import React from 'react';

const BabyAge = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.3799 3.25C17.7941 3.25 18.1299 3.58579 18.1299 4V5.43164H19.5566L19.6338 5.43555C20.0118 5.47409 20.3066 5.79341 20.3066 6.18164C20.3066 6.56987 20.0118 6.88919 19.6338 6.92773L19.5566 6.93164H18.1299V8.36328L18.126 8.44043C18.0874 8.81846 17.7681 9.11328 17.3799 9.11328C16.9918 9.11306 16.6723 8.81836 16.6338 8.44043L16.6299 8.36328V6.93164H15.1934C14.7791 6.93164 14.4434 6.59585 14.4434 6.18164C14.4434 5.76743 14.7791 5.43164 15.1934 5.43164H16.6299V4C16.6299 3.58593 16.9659 3.25024 17.3799 3.25Z"
            fill="black"
        />
        <path
            d="M11.4434 5.25C11.8185 5.25 12.1881 5.27639 12.5498 5.32812C12.9596 5.38686 13.244 5.76689 13.1855 6.17676C13.1269 6.5868 12.747 6.87213 12.3369 6.81348C12.0454 6.7718 11.7472 6.75 11.4434 6.75C7.99158 6.75 5.19336 9.54822 5.19336 13C5.19336 16.4518 7.99158 19.25 11.4434 19.25C14.8951 19.25 17.6934 16.4518 17.6934 13C17.6934 12.4593 17.6245 11.9353 17.4961 11.4365C17.3932 11.0355 17.6352 10.6266 18.0361 10.5234C18.4372 10.4204 18.846 10.6624 18.9492 11.0635C19.1087 11.6832 19.1934 12.3323 19.1934 13C19.1934 17.2802 15.7236 20.75 11.4434 20.75C7.16315 20.75 3.69336 17.2802 3.69336 13C3.69336 8.71979 7.16315 5.25 11.4434 5.25Z"
            fill="black"
        />
        <path
            d="M9.44336 11.25L9.44336 12.25"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.4434 11.25L13.4434 12.25"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.88525 15.25C9.41296 16.109 10.3612 16.6819 11.4433 16.6819C12.5254 16.6819 13.4736 16.109 14.0013 15.25"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

export default BabyAge;
